module.exports = __webpack_public_path__ + "static/media/visapur.b1136a16.jpg";